import { Dispatch, FC, SetStateAction, useState } from "react";
import {
  useAppDispatch,
  useAppSelector as useSelector,
} from "../../../../store";
import Bus from "../../../UI/Icons/Bus";
import Car from "../../../UI/Icons/Car";
import Train from "../../../UI/Icons/Train";
import Tram from "../../../UI/Icons/Tram";
import PopupModal from "../../../UI/Popup";
import ReadMore from "../../../UI/ReadMore";
import CentreTimings from "./CentreTimings";
// import InactiveOutline from "../../../UI/Icons/InactiveOutline";
import { Link, useLocation, useNavigate } from "react-router";
import DefaultImg from "../../../../assets/img/default-image.svg";
import { STORAGE_KEYS } from "../../../../constants/storageKeys";
import Roles from "../../../../models/roles";
import { AUTH_ROUTE } from "../../../../pages/App/routes";
import {
  hideTransparentPreloaderAction,
  showTransparentPreloaderAction,
} from "../../../../store/application/slice";
import {
  makeCentrePrefferedThunk,
  removeCentrePrefferedThunk,
} from "../../../../store/candidate/thunks";
import { TTiming } from "../../../../store/superadmin/types";
import storage from "../../../../utils/storage";
import CandidateJobButton from "../../../Candidate/CandidateJobButton";
import CustomButton from "../../../UI/Buttons/CustomButton";
import Copy from "../../../UI/Icons/Copy";
import VacancyPosition from "../../../UI/VacancyPosition";
import { formatTimeframes } from "../../../Vacancy/timeframeApiHelper";

interface ViewCentreProps {
  showViewModal: boolean;
  setShowViewModal: Dispatch<SetStateAction<boolean>>;
  centreId?: number;
  handleView?: (id: number) => void;
  getCandidateJobList?: () => void;
  setShowAcceptedJobs?: (show: boolean) => void;
  onRefresh?: () => void;
  showSingleDayView?: (show: boolean) => void;
}

interface TransportMode {
  id: number;
  centre_id: number;
  transport_mode: string;
  parking_on_site: number;
  parking_on_surrounding: number;
  created_at: string | null;
  updated_at: string | null;
}

const ViewCentre: FC<ViewCentreProps> = ({
  showViewModal,
  setShowViewModal,
  handleView,
  centreId,
  getCandidateJobList,
  setShowAcceptedJobs,
  onRefresh,
  showSingleDayView
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const centreDetails = useSelector((state) => state.superadmin.centreDetails);
  const user = useSelector((state) => state.auth.user);

  const [codeCopied, setCodeCopied] = useState<boolean>(false);
  const [isPreferred, setIsPreferred] = useState<boolean>(
    !!centreDetails?.centre?.isPreferred
  );

  // const handleMakeInactive = async (id: number) => {
  //   dispatch(showTransparentPreloaderAction());
  //   setShowViewModal(false);
  //   await dispatch(centreInactiveThunk({ centre_id: id }));
  //   dispatch(hideTransparentPreloaderAction());
  // };

  const handleCopyText = (type: "codeDiv") => {
    const referralCode = document.getElementById(type);

    if (!referralCode) {
      console.error(`Element with id ${type} not found.`);
      return;
    }

    const textToCopy = referralCode.innerText; // Get the text from the div
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        if (type === "codeDiv") {
          setCodeCopied(true);
        }

        setTimeout(() => {
          setCodeCopied(false);
        }, 5000);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  const onClickClose = async () => {
    getCandidateJobList && getCandidateJobList();
    setShowViewModal(false);
  };

  const formatDateToReadable = (isoDateString: string): string => {
    if (isoDateString === "") {
      return "-";
    }
    const date = new Date(isoDateString);
    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
      year: "numeric",
    };
    return new Intl.DateTimeFormat("en-GB", options).format(date);
  };

  const handleMakePreferred = async (id: number) => {
    dispatch(showTransparentPreloaderAction());
    await dispatch(
      makeCentrePrefferedThunk({
        centre_id: id,
        centre_uuid: centreDetails?.centre?.uuid || "",
      })
    );
    dispatch(hideTransparentPreloaderAction());
    setIsPreferred(true);
  };

  const handleRemovePreferred = async (id: number) => {
    dispatch(showTransparentPreloaderAction());
    await dispatch(
      removeCentrePrefferedThunk({
        centre_id: id,
        centre_uuid: centreDetails?.centre?.uuid || "",
      })
    );
    dispatch(hideTransparentPreloaderAction());
    setIsPreferred(false);
  };

  const handleViewDetails = async (id: string) => {
    storage.set(STORAGE_KEYS.SELECTED_VACANCY_ID, id);
    navigate(
      location.pathname.includes("admin")
        ? AUTH_ROUTE.ADMIN_PENDING_VACANCIES
        : AUTH_ROUTE.PENDING_VACANCY
    );
  };

  return (
    <>
      <PopupModal
        visible={showViewModal}
        showCloseBtn={true}
        onClickClose={onClickClose}
        customWidth={1000}
      >
        <>
          <div className="d-flex flex-column gap-20">
            <div className="d-flex flex-column flex-lg-row gap-50 gap-mobile-20 align-items-lg-center">
              <div className="min-w-210px">
                <div className="bg-off-white min-w-100px w-100px h-100px rounded-circle">
                  <img
                    className="fixed-size-image"
                    src={
                      centreDetails?.centre?.photo
                        ? centreDetails?.centre?.photo
                        : DefaultImg
                    }
                    alt={"centre-profile-image"}
                  />
                </div>
              </div>
              <div className="h-100px w-1px bg-off-white d-none d-lg-block"></div>
              <div className="d-flex gap-30 flex-wrap align-items-center">
                <div className="d-flex flex-column gap-10 min-w-280px w-280px mobile-w-100 text-break lh-24px">
                  {/* {user?.role.name === Roles.CANDIDATE && (
                    <div className="d-flex">
                      {!isPreferred ? (
                        <div
                          className="border border-off-white py-4px px-8px radius-8px cursor-pointer"
                          onClick={() =>
                            centreDetails?.centre?.id &&
                            handleMakePreferred(centreDetails.centre.id)
                          }
                        >
                          <div className="fs-13 fw-400 lh-14px text-grey-light">
                            Mark as Preferred?
                          </div>
                        </div>
                      ) : (
                        <div
                          className="border bg-teal-pale border-teal-dark px-8px radius-8px d-flex gap-4 align-items-center cursor-pointer"
                          onClick={() =>
                            centreDetails?.centre?.id &&
                            handleRemovePreferred(centreDetails.centre.id)
                          }
                        >
                          <div className="fs-13 fw-400 lh-14px text-teal-dark">
                            Preferred
                          </div>
                          <div className="cursor-pointer">
                            <Cross />
                          </div>
                        </div>
                      )}
                    </div>
                  )} */}
                  <div className="fs-30 fw-400 text-black">
                    {centreDetails?.centre?.business_name}
                  </div>
                  <div className="fs-16 fw-400 text-black" id="codeDiv">
                    {centreDetails?.centre?.address}
                  </div>
                  {user?.role.name === Roles.CANDIDATE && (
                    <div className="d-flex">
                      <CustomButton
                        variant={"primary"}
                        type="button"
                        className="btn-theme bg-off-white text-black max-h-30px"
                        onClick={() => handleCopyText("codeDiv")}
                      >
                        <Copy />
                        Copy Address
                      </CustomButton>
                    </div>
                  )}
                  {codeCopied && (
                    <div className="text-teal-dark">
                      Centre address copied to clipboard
                    </div>
                  )}
                </div>

                {user?.role.name !== Roles.CANDIDATE && (
                  <div className="d-flex gap-20 align-items-center">
                    <div className="d-flex flex-column gap-3">
                      <div className="fs-13 fw-400 text-grey-medium">
                        Filled and Historic
                      </div>
                      <div className="fs-16 fw-400 text-black">
                        {centreDetails?.centre.filled_vacancies_count}{" "}
                        {centreDetails?.centre.filled_vacancies_count &&
                        centreDetails?.centre.filled_vacancies_count > 1
                          ? "Vacancies"
                          : "Vacancy"}
                      </div>
                    </div>
                    <div className="d-flex flex-column gap-3">
                      <div className="fs-13 fw-400 text-grey-medium">
                        Cancellations
                      </div>
                      <div className="fs-16 fw-400 text-black">
                        {centreDetails?.centre.cancelled_vacancies_count}{" "}
                        {centreDetails?.centre.cancelled_vacancies_count &&
                        centreDetails?.centre.cancelled_vacancies_count > 1
                          ? "Vacancies"
                          : "Vacancy"}
                      </div>
                    </div>
                  </div>
                )}

                {user?.role.name === Roles.CANDIDATE && (
                  <div className="d-flex gap-20 align-items-center">
                    <div className="d-flex flex-column gap-3">
                      <div className="fs-22 fw-400 text-black">
                        {centreDetails?.centre?.total_vacancies_posted}{" "}
                      </div>
                      <div className="fs-13 fw-400 text-grey-medium">
                        Past Jobs at <br />{" "}
                        {centreDetails?.centre?.business_name}
                      </div>
                    </div>
                    <div className="d-flex flex-column gap-3">
                      <div className="fs-22 fw-400 text-black">
                        {formatDateToReadable(
                          centreDetails?.centre?.last_posted_job || ""
                        )}
                      </div>
                      <div className="fs-13 fw-400 text-grey-medium">
                        Last Job at <br />{" "}
                        {centreDetails?.centre?.business_name}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="h-1px w-100 bg-grey-light"></div>
            <div className="d-flex flex-column flex-lg-row gap-50">
              <div className="d-flex gap-20 flex-column justify-content-between flex-grow min-w-210px fs-16 fw-400 text-black">
                <div className="d-flex gap-12 flex-column">
                  <div className="fw-700">Opening Hours</div>
                  <CentreTimings
                    schedule={centreDetails?.centre?.timings as TTiming[]}
                  />
                </div>
                {/* <div className="d-flex">
                  <CustomButton
                      variant={"primary"}
                      type="button"
                      className="btn-theme bg-off-white text-black"
                      contentClass="d-flex"
                      onClick={() => handleMakeInactive(centreDetails.centre?.id)}
                  >
                      <InactiveOutline />
                      Make Inactive
                  </CustomButton>
                </div> */}
              </div>
              <div className="w-1px bg-off-white d-none d-lg-block"></div>
              <div className="d-flex flex-column gap-25">
                <div className="d-flex gap-30 flex-wrap">
                  <div className="d-flex flex-column gap-3">
                    <div className="fs-13 fw-400 text-grey-medium">Website</div>
                    {centreDetails?.centre.website ? (
                      <div className="text-decoration-underline">
                        <Link
                          to={centreDetails?.centre?.website}
                          target="_blank"
                          className="fs-16 fw-400 text-black"
                        >
                          {centreDetails?.centre?.website}
                        </Link>
                      </div>
                    ) : (
                      <div className="fs-16 fw-400 text-black">-</div>
                    )}
                  </div>
                  <div className="d-flex flex-column gap-3">
                    <div className="fs-13 fw-400 text-grey-medium">Phone</div>
                    <div className="fs-16 fw-400 text-black">
                      {centreDetails?.centre.phone_number ?? "-"}
                    </div>
                  </div>
                  <div className="d-flex flex-column gap-3">
                    <div className="fs-13 fw-400 text-grey-medium">ABN</div>
                    <div className="fs-16 fw-400 text-black">
                      {centreDetails?.centre.abn ?? "-"}
                    </div>
                  </div>
                  <div className="d-flex flex-column gap-3">
                    <div className="fs-13 fw-400 text-grey-medium">
                      Licensed places
                    </div>
                    <div className="fs-16 fw-400 text-black">
                      {centreDetails?.centre?.placements ?? "-"}
                    </div>
                  </div>
                </div>

                <div className="d-flex flex-column gap-3">
                    <div className="fs-13 fw-400 text-grey-medium">Email Address (To be used for invoicing)</div>
                    <div className="fs-16 fw-400 text-black">
                      {centreDetails?.centre.centre_invoice_email ?? "-"}
                    </div>
                </div>

                <div className="d-flex flex-column gap-3">
                  <div className="fs-16 fw-700 text-black">Centre Profile</div>
                  <ReadMore lines={2}>
                    {centreDetails?.centre?.profile ?? "-"}
                  </ReadMore>
                </div>
                <div className="d-flex flex-column gap-3">
                  <div className="fs-16 fw-700 text-black">
                    Centre Expectations
                  </div>
                  <div className="fs-16 fw-400 text-black">
                    {centreDetails?.centre?.expectations ?? "-"}
                  </div>
                </div>
                <div className="d-flex flex-column gap-5">
                  <div className="fs-16 fw-700 text-black">Transport</div>
                  <div className="d-flex flex-column">
                    {centreDetails?.centre?.transport.some(
                      (mode: TransportMode) =>
                        ["car"].includes(mode?.transport_mode)
                    ) && (
                      <>
                        {centreDetails?.centre?.transport.map(
                          (mode: TransportMode, index: number) =>
                            mode?.transport_mode === "car" && (
                              <div
                                key={index}
                                className="py-5px d-flex flex-column"
                              >
                                <div className="d-flex gap-20 align-items-center">
                                  <div className="py-5px d-flex flex-column">
                                    <Car />
                                  </div>
                                  <div className="fs-16 fw-400 text-black">
                                    {`Parking available on ${
                                      mode?.parking_on_site === 1 &&
                                      mode?.parking_on_surrounding === 0
                                        ? "site"
                                        : mode?.parking_on_site === 0 &&
                                          mode?.parking_on_surrounding === 1
                                        ? "surrounding streets"
                                        : "site and surrounding streets"
                                    }`}
                                  </div>
                                </div>
                              </div>
                            )
                        )}
                      </>
                    )}
                    {centreDetails?.centre?.transport.some(
                      (mode: TransportMode) =>
                        ["train", "bus", "tram"].includes(mode?.transport_mode)
                    ) && (
                      <div className="d-flex gap-20 align-items-center">
                        {centreDetails?.centre?.transport.map(
                          (mode: TransportMode, index: number) =>
                            ["train", "bus", "tram"].includes(
                              mode?.transport_mode
                            ) && (
                              <div
                                key={index}
                                className="py-5px d-flex flex-column"
                              >
                                {mode?.transport_mode === "bus" && <Bus />}
                                {mode?.transport_mode === "train" && <Train />}
                                {mode?.transport_mode === "tram" && <Tram />}
                              </div>
                            )
                        )}
                        <div className="fs-16 fw-400 text-black">
                          Public transport located less than 15min walk away
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="d-flex flex-column gap-10">
                  <div className="fs-16 fw-700 text-black">
                    Current Job Listings
                  </div>
                  <div className="d-flex gap-10 flex-wrap">
                    {centreDetails?.centre?.latest_jobs &&
                    centreDetails.centre.latest_jobs.length !== 0 ? ( // temporary disabled
                      centreDetails.centre.latest_jobs.map(
                        (job: any, index: number) => (
                          <div
                            key={index}
                            className="border border-grey-black radius-8px min-w-290px w-290px mobile-w-100 text-break"
                          >
                            <div className="px-10px py-15px d-flex flex-column gap-10">
                              <div className="d-flex flex-column gap-3">
                                <div className="fs-10 fw-400 text-grey-medium">
                                  Position
                                </div>
                                <div className="fs-13 fw-400 text-black">
                                  <VacancyPosition
                                    positions={job.vacancy_positions}
                                    alternatePosition={
                                      job.alternate_position_legacy
                                    }
                                  />
                                </div>
                              </div>
                              <div className="d-flex flex-column gap-3">
                                <div className="fs-10 fw-400 text-grey-medium">
                                  Requested Timeframe
                                </div>
                                <div className="fs-13 fw-600 text-alert">
                                  {job?.timeframes &&
                                    formatTimeframes(job?.timeframes)?.map(
                                      (formatedTimeData, index) => (
                                        <div
                                          key={index}
                                          className={`fs-13 ${
                                            formatedTimeData.alert
                                              ? "text-alert fw-700"
                                              : "fw-400"
                                          }`}
                                        >
                                          {formatedTimeData.label}
                                        </div>
                                      )
                                    )}
                                </div>
                              </div>
                              <div className="w-1px h-1px"></div>
                              {user?.role.name === Roles.CANDIDATE ? (
                                <CandidateJobButton showSingleDayView={showSingleDayView} onRefresh={onRefresh} setShowAcceptedJobs={setShowAcceptedJobs} vacancyDetails={job} getCandidateJobList={getCandidateJobList} handleView={handleView} setShowViewModal={setShowViewModal}  isDocumentsExpired={job.is_documents_expired} />
                              ) : (
                                <CustomButton
                                  variant={"primary"}
                                  type="button"
                                  className="btn-theme bg-teal text-black max-h-30px w-100"
                                  onClick={() => handleViewDetails(job?.uuid)}
                                >
                                  View Details
                                </CustomButton>
                              )}
                            </div>
                          </div>
                        )
                      )
                    ) : (
                      <div className="fs-13 fw-400 text-grey-medium">
                        No Jobs Currently
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </PopupModal>
    </>
  );
};

export default ViewCentre;
